import { render, staticRenderFns } from "./KidsExcelTable.vue?vue&type=template&id=c9bb1530&scoped=true"
import script from "./KidsExcelTable.vue?vue&type=script&lang=js"
export * from "./KidsExcelTable.vue?vue&type=script&lang=js"
import style0 from "./KidsExcelTable.vue?vue&type=style&index=0&id=c9bb1530&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bb1530",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9bb1530')) {
      api.createRecord('c9bb1530', component.options)
    } else {
      api.reload('c9bb1530', component.options)
    }
    module.hot.accept("./KidsExcelTable.vue?vue&type=template&id=c9bb1530&scoped=true", function () {
      api.rerender('c9bb1530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/ByClass/KidsExcelTable.vue"
export default component.exports